import { useEffect, useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "./Home.css";
import { Zoom, Fade, Slide } from "react-awesome-reveal";
import CallbackPopup from "../../../components/common/CallbackPopup";
import CountUp from "react-countup";
import ContactUs from "../components/ContactUs";
import About from "../components/About";
import phoneIcon from "../../../assets/phone_icon1.svg";
import Services from "../components/Services";
import WhyUs from "../components/WhyUs";
import Accreditations from "../components/Accreditations";
import UploadProjectForm from "../../../components/common/UploadProjectForm";
import OurServices from "../components/OurServices";
import ProjectsSection from "../components/ProjectsSection";
import OurTeam from "../components/OurTeam";
import ClientPortalShowcase from "../components/ClientPortalShowcase";
import houseImg from "../../../assets/house_model02-cropped.jpeg";
import { Typed } from "react-typed";
import { TypeAnimation } from "react-type-animation";
import { motion, AnimatePresence } from "framer-motion";

function Home() {
  const texts = [
    "Comprehensive solutions for your dream home or commercial project with Inspired Innovation.",
    "We transform visions into reality with innovative infrastructure solutions for homes and commercial projects.",
  ];
  const [popupOpen, setPopupOpen] = useState(false);

  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % texts.length);
    }, 5000); // change text every 3 seconds

    return () => clearInterval(timer);
  }, []);

  //whatsapp button
  const phoneNumber = "918761005772";
  const message = "Hello! I want to know more about your services.";

  const handleClick = () => {
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message,
    )}`;
    window.location.href = url;
  };

  return (
    <div className="home-container">
      <section id="home">
        <Row className="intro-container ">
          <Col className="landing-text-container" xs={12} sm={12} md={8} lg={8}>
            <Zoom>
              <div className="text-component-container">
                <h3 className="vision">
                  YOUR VISION, OUR EXPERTISE -{" "}
                  <span className="font-bold">LET'S BUILD IT!</span>
                </h3>

                <div>
                  <h1 className="spirent-name">
                    SPIRENT{" "}
                    <span className="spirent-name highlighted-india">
                      INDIA
                    </span>{" "}
                    INFRATECH
                  </h1>

                  <h1 className="spirent-name">PRIVATE LIMITED</h1>
                </div>

                <div className="orange-bar"></div>

                <p className="changing-para">
                  <AnimatePresence mode="wait">
                    <motion.p
                      key={texts[index]}
                      initial={{ opacity: 0, y: 5 }}
                      animate={{ opacity: 1, y: 0 }}
                      exit={{ opacity: 0, y: -5 }}
                      transition={{ duration: 0.6 }}
                      style={{ position: "absolute" }}
                    >
                      {texts[index]}
                    </motion.p>
                  </AnimatePresence>
                </p>

                <Row className="count-container mt-4">
                  <Col className="counter-box ">
                    <div>
                      <h2 className="count">
                        <CountUp
                          start={0}
                          end={1500}
                          duration={2.5}
                          separator=","
                        />
                        +
                      </h2>
                      <span className="counter-text">Clients</span>
                    </div>
                  </Col>

                  <Col className="counter-box">
                    <div>
                      <h2 className="count">
                        <CountUp
                          start={0}
                          end={150}
                          duration={2.5}
                          separator=","
                        />
                        +
                      </h2>
                      <span className="counter-text">Projects</span>
                    </div>
                  </Col>

                  <Col className="counter-box">
                    <div>
                      <h2 className="count">
                        <CountUp
                          start={0}
                          end={50}
                          duration={2.5}
                          separator=","
                        />
                        +
                      </h2>
                      <span className="counter-text">Members</span>
                    </div>
                  </Col>
                  <Col className="counter-box">
                    {" "}
                    <div className="experience-box">
                      <div className="top-box">10+</div>
                      <div className="bottom-box"> Years of Experience</div>
                    </div>
                  </Col>
                </Row>

                <div className="wp-btn-container">
                  <button
                    className="wp-btn"
                    onClick={handleClick}
                    style={{
                      backgroundColor: "#25D366",
                      color: "white",
                      border: "none",
                      borderRadius: "50px",
                      padding: "10px 20px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <img
                      src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
                      alt="whatsapp"
                      style={{ width: "20px", height: "20px" }}
                    />
                    WhatsApp us
                  </button>

                  <button
                    className="wp-btn callback-btn"
                    onClick={() => setPopupOpen(true)}
                    style={{
                      // backgroundColor: "#25abf3",
                      color: "WHITE",
                      borderRadius: "50px",
                      padding: "10px 20px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <img
                      className="phone-icon"
                      src={phoneIcon}
                      alt="phone"
                      style={{ width: "20px", height: "20px", color: "black" }}
                    />
                    Request callback
                  </button>
                  <CallbackPopup open={popupOpen} setOpen={setPopupOpen} />
                </div>
              </div>
            </Zoom>
          </Col>

          <Col className="right-column" xs={12} sm={12} md={4} lg={4}>
            <div className="d-flex">
              {/* <div className="experience-box">
                <div className="top-box">10+</div>
                <div className="bottom-box"> Years of Experience</div>
              </div> */}
              {/* <div className="experience-box">
                NO-1 constructino company in north east
                {/* <div className="bottom-box">Experience</div>

                <div className="top-box">10+ Years</div>  }
              </div> */}
            </div>
            <img
              src={houseImg}
              alt="Description of the image for accessibility"
              className="persons_image"
            />
          </Col>
        </Row>
      </section>
      <ClientPortalShowcase onRequestCallback={() => setPopupOpen(true)} />

      <section id="about">
        <About />
      </section>

      <section id="whyus">
        <WhyUs></WhyUs>
      </section>

      <section id="services">
        <div className="our-services=-container">
          <Row className="our-services">
            {" "}
            <OurServices />
          </Row>
        </div>
        <Services />
        {/* <UploadProjectForm /> */}
      </section>

      {/* <section id="works">
        <ProjectsSection />
      </section> */}
      <section id="team">
        <OurTeam />
      </section>

      <section id="accreditations">
        <Accreditations />
      </section>

      <section id="contact_us">
        <ContactUs />
      </section>
    </div>
  );
}

export default Home;
